/* eslint-disable */
import { useParams } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const host = process.env.REACT_APP_BACKEND_URL;


export default function LoginAs() {
    const { id } = useParams();
    const handleSubmit = async() => {
        const res = await fetch(`${host}` + "/loginAs", {
            method: "POST",
            headers: {Accept: "application/json","Content-Type": "application/json",},
            body: JSON.stringify({auth_key: id}),
            // credentials: 'include',
        });
        const data = await res.json();
        if(data.status === 200){

            localStorage.clear(); 
            // console.log(data.token.original)
            localStorage.setItem('token', data.token.original.access_token)
            localStorage.setItem('user_id', data.user_details.id)
            localStorage.setItem('auth_key', data.user_details.auth_key)
            localStorage.setItem('name', data.user_details.name)
            localStorage.setItem('username', data.user_details.username)
            localStorage.setItem('wa_auth_key', data.user_details.wa_auth_key)


            toast.success(data.message)
            window.location.href = '/new'
        }else {
            console.log(data)
            toast.error('Please check your Auth Key');
            localStorage.clear(); 
            window.location.href = '/'
        }
    };

    handleSubmit();
    return (<p><ToastContainer/></p>);
}